import { DateRange } from "react-day-picker";
import { create } from "zustand"

import {getDaysPlus, getNow, getYearsAgo} from "@/lib/filters/date/date-utils";
import {LOCAL_STORAGE_KEY_DATE_FILTER} from "@/utils/keys";

type DateFilterStore = {
  date: DateRange,
  setDate: (date: DateRange) => void,
  resetDate: () => void,
}

const defaultDate = {
  from: getDaysPlus(1, getYearsAgo(1, getNow())),
  to: getNow(),
}
export const useDate = create<DateFilterStore>(set => ({
  date: getDateFromLocalStorage(),
  setDate: (date: DateRange) => {
    set({ date })
    setDateToLocalStorage(date)
  },
  resetDate: () => {
    set({ date: defaultDate})
    setDateToLocalStorage(defaultDate)
  }
}))

function getDateFromLocalStorage() {
  const dateFilter = localStorage.getItem(LOCAL_STORAGE_KEY_DATE_FILTER)
  if (!dateFilter) {
    return defaultDate
  }

  return JSON.parse(dateFilter)
}

function setDateToLocalStorage(date: DateRange) {
  localStorage.removeItem(LOCAL_STORAGE_KEY_DATE_FILTER)
  localStorage.setItem(LOCAL_STORAGE_KEY_DATE_FILTER, JSON.stringify(date))
}